export default __webpack_public_path__ + "static/media/Group-29.b631776f.svg";